import { useEffect } from "react";
import { useI18n } from "../i18n/I18nContext";

// Lightweight SEO: sets title + meta description per page. No analytics.
export function useSeo(title, description) {
  const { lang } = useI18n();
  useEffect(() => {
    const suffix = "Résidence Doux Instants · RPA Laval";
    document.title = title ? `${title} — ${suffix}` : suffix;
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "description";
      document.head.appendChild(meta);
    }
    if (description) meta.setAttribute("content", description);
    document.documentElement.lang = lang;
  }, [title, description, lang]);
}
